import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Signin from './Signin';
import Signup from './Signup';
import MainApp from './MainApp';

interface User {
  user_id: string;
  email: string;
  name?: string;
}

function App() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const BACKEND_URL = "https://gln7w8w5uc.execute-api.ap-south-1.amazonaws.com/dev";
  //const BACKEND_URL = "http://localhost:5000";


  useEffect(() => {
    // If you're on an auth route, skip fetching user data.
    if (location.pathname === '/signin' || location.pathname === '/signup') {
      setLoading(false);
      return;
    }

    console.log("Fetching user data...");
    fetch(`${BACKEND_URL}/me`, {
      credentials: "include",
    })
      .then((res) => {
        console.log("Response status:", res.status);
        if (res.ok) return res.json();
        if (res.status === 401) {
          setUser(null);
          navigate('/signin');
          throw new Error("Unauthorized");
        }
        throw new Error("Not authenticated");
      })
      .then((data) => {
        console.log("User data:", data);
        setUser(data);
      })
      .catch((err) => {
        console.error("Error fetching user data:", err);
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, [navigate, location]);

  if (loading) {
    return <div>Loading...</div>; // Show a loading indicator while fetching user data
  }

  return (
    <Routes>
      <Route path="/signin" element={user ? <Navigate to="/app" /> : <Signin />} />
      <Route path="/signup" element={user ? <Navigate to="/app" /> : <Signup />} />
      <Route path="/app" element={user ? <MainApp user={user} /> : <Navigate to="/signin" />} />
      <Route path="/" element={<Navigate to={user ? "/app" : "/signin"} replace />} />
      <Route path="*" element={<Navigate to={user ? "/app" : "/signin"} replace />} />
    </Routes>
  );
}

export default App;